import { render } from "./TrainerSessionManagement.vue?vue&type=template&id=8c8ae28a&scoped=true"
import script from "./TrainerSessionManagement.vue?vue&type=script&lang=js"
export * from "./TrainerSessionManagement.vue?vue&type=script&lang=js"

import "./TrainerSessionManagement.vue?vue&type=style&index=0&id=8c8ae28a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8ae28a"]])

export default __exports__